import contactFrag from "./Contact";
import ExhibitionWork from "./ExhibitionWork";

const Exhibition = ({
  contact = false,
  exhibitionWorks = { consignmentPurchase: false, offer: false },
} = {}) => `
  id
  artFair
  channelPresentation
  ${
    contact
      ? `contact {
      ${contactFrag(contact)}
    }`
      : ""
  }
  contactId
  curator
  endDate
  endDay
  endMonth
  endYear
  ${
    exhibitionWorks
      ? `exhibitionWorks {
      ${ExhibitionWork(exhibitionWorks)}
    }`
      : ""
  }
  fullDate
  notes
  sageCode
  startDate
  startDay
  startMonth
  startYear
  title
  type
  updatedAt
`;

export default Exhibition;
